export const withResetStateConst = {
	RESET_GLOBAL_STATE: "RESET_GLOBAL_STATE",
};
